import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function SsidChartIcon(props: IconProps) {
    return <Icon {...props} iconKey={"ssid_chart"}/>
}
